module.exports = __webpack_public_path__ + "img/02f_marketing.57af2737.jpg";